import { render, staticRenderFns } from "./CriterionInputNumber.vue?vue&type=template&id=67b9b002&scoped=true&"
import script from "./CriterionInputNumber.vue?vue&type=script&lang=js&"
export * from "./CriterionInputNumber.vue?vue&type=script&lang=js&"
import style0 from "./CriterionInputNumber.vue?vue&type=style&index=0&id=67b9b002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b9b002",
  null
  
)

export default component.exports